import React, { useEffect, useState } from 'react';
import FastbetDropdownContent from './FastbetDropdownContent';

function FastbetDropdown(props) {
    const [showDropdown, setShowDropdown] = useState(false);
    
    function toggle() {
        setShowDropdown(function(prev) {
            return !prev;
        });
    }

    function handleClick() {
        props.toggleMoreBets();
    }

    const dropdownId = `apri-fastbet-in-quote-${props.id}`;
    useEffect(() => {
        window.addEventListener(`close-fastbet-dropdown-${props.id}`, () => {
            window.$(`#${dropdownId}`).dropdown('toggle');
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
   
    // To limit number of elements in DOM
    // dropdown content will be rendered only when showed
    useEffect(function() {
        const $trigger = window.$('#dropdown-' + props.id);
        $trigger.on('show.bs.dropdown', toggle);
        $trigger.on('hide.bs.dropdown', function(e){
            if(e.clickEvent && e.clickEvent.target && e.clickEvent.target.classList.contains('fast-bets-odd')) {
                return false;
            }else{
                toggle();
                return true;
            }
        });
    }, [props.id]);

    return (
        <>
            <span className="margine-dx-mezzo pointer" onClick={handleClick}>{(props.moreBetsToggled ? '-' : '+')}{props.match.avvRef == null && props.match.plus}</span>
            <div className="dropdown fastbet-in-quote" id={"dropdown-" + props.id}>
                <i className="fas fa-caret-square-down pointer" id={dropdownId} data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"></i>
                <div className="dropdown-menu" aria-labelledby={dropdownId}>
                    {showDropdown &&
                        <FastbetDropdownContent match={props.match} />
                    }
                </div>
            </div>
        </>
    );
}

export default FastbetDropdown;